import React, { Component } from "react";
import Axios from "axios";
import "./PlotDentOnImage.css";
import { configuration } from "../../appConfig";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class PlotDentOnExtraImage extends Component {
  state = {
    dents: [],
    zoomLevel: 25,
    division: 2,
    checked: true,
    dentCount: 0,
    dentColor: "yellow",
    dentSize: "A",
    notes: "",
  };

  getData = async () => {
    const response = await Axios.get(
      configuration.getExtraImageDents +
        "?part=" +
        this.props.part.split(".")[0] +
        "&vin=" +
        this.props.vin +
        "&partnerId=" +
        this.props.partnerId
    );

    //driveandscan.de/scanImages/001-sandip/WAUZZZ8X7EB166057/501406923.json

    if (response.data) {
      const str = await response.data.json;
      if (str) {
        const data = JSON.parse(str);
        this.setState({
          dents: data.dents,
          notes: data.notes,
        });
      }
    }
  };
  click = (el) => {
     if (this.props.authorized) {
      return
    }
    let size = window.prompt(
      "Provide Circle Diameter for " + this.state.dentSize
    );
    //  if (!result) return;
    //alert(size);
    const elm = el.target;
    const cord = elm.getBoundingClientRect();
    size = parseInt(size);
    var sizes = {
      A: 50,
      B: 30,
      C: 20,
    };

    const radius = size / 2;

    const x = (el.pageX * 100) / this.state.zoomLevel - cord.left - radius;
    const y = (el.pageY * 100) / this.state.zoomLevel - cord.top - radius;
    //const x = (el.pageX * 100) / this.state.zoomLevel;
    //const y = (el.pageY * 100) / this.state.zoomLevel;
    //var xx = x;
    // var yy = y;

    // const result = this.average(this.state.dents) || 20;

    if (this.state.checked) {
      const indx = this.state.dents.length;

      this.setState(
        (state) => {
          const list = state.dents.concat([
            {
              type: this.state.dentSize,
              size,
              x: x,
              y: y,
            },
            // `${indx + 1} ${
            //   yy.toFixed(6) + " " + xx.toFixed(6)
            // } ${parseInt(result).toFixed(6)} 1`,
          ]);
          return {
            dents: list,
            dentCount: state.dentCount + 1,
          };
        },
        () => {
          // this.serverUploadFormat();
        }
      );
    }
  };
  serverUploadFormat = () => {
    // const payload = this.state.dents.map((res, index) => {
    //   const dd = res.split(" ");
    //   return `${index} ${dd[1]} ${dd[2]} ${dd[3]} 1`;
    // });
    // const str = payload.toString().replace(/,/g, "++++");
    //this.props.saveChanges(str);
    this.saveChanges(this.state.dents);
    //  // return str
  };
  saveChanges = (payload) => {
    const url = configuration.PostExtraImageDents;

    let data = {
      dents: payload,
      part: this.props.part.split(".")[0],
      vin: this.props.vin,
      partnerId: this.props.partnerId,
      notes: this.state.notes,
      id:this.props.id
    };
    Axios.post(url, data).then((res) => {
      alert("Dents uploaded.");
    });

  };
  average = (arr) => {
    if (arr.length) {
      return (
        arr.reduce((p, c) => {
          let arrp = [];
          if (p.length > 5) {
            arrp = p.split(" ");
          } else {
            arrp[3] = p;
          }
          const arrc = c.split(" ");
          return parseInt(arrp[3]) + parseInt(arrc[3]);
        }) / arr.length
      );
    } else {
      return 20;
    }
  };

  componentDidMount() {
    this.getData();
  }
  remove = (i) => {
    // const result = window.prompt("Do you want to remove dent spot?");
    //  if (!result) return;
    this.setState(
      (state) => {
        //...state.dents,
        const list = state.dents.filter((row, index) => {
          return index !== i;
        });
        //  const list = state.dents.concat(`78 ${el.pageX} ${el.pageY} 21.136816 1`);
        return {
          dents: list,
          dentCount: state.dentCount - 1,
        };
      },
      () => {
        this.serverUploadFormat();
        // alert('changes removed');
      }
    );
  };
  zoom = (zoom) => {
    if (zoom === "--") {
      this.state.zoomLevel > 20 &&
        this.setState({
          zoomLevel: this.state.zoomLevel - 10,
          division: this.state.division + 2,
        });
    } else {
      this.setState({
        zoomLevel: this.state.zoomLevel + 10,
        division: this.state.division - 2,
      });
    }
    if (zoom === "reset") {
      this.setState({ zoomLevel: 30, division: 2 });
    }
  };

  onchange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { dents, dentCount } = this.state;
    const colorCode = {
      A: "red",
      B: "orange",
      C: "yellow",
    };
    var sizes = {
      A: 35,
      B: 25,
      C: 5,
    };
    return (
      <div>
        <div
          className="row controls-bar mb-2"
          style={{ display: this.props.controls ? "" : "none" }}
        >
          <select
            name="dentSize"
            onChange={this.onchange}
            className="form-control col-2 mr-2 dropdown"
          >
            <option value="A">A : Previous Damage</option>
            <option value="B">B : Parking Damage</option>
            <option value="C">C : Other Damage</option>
            {/* <option value="C">C : Paint Damage</option> */}
          </select>

          <button
            className="btn btn-success ml-2 mr-2"
            onClick={() => this.zoom("--")}
          >
            <i className="fa fa-search-minus"></i>
          </button>
          {/* <button onClick={() => this.zoom("reset")}>Reset</button> */}
          <button
            className="btn btn-success mr-2"
            onClick={() => this.zoom("++")}
          >
            <i className="fa fa-search-plus" aria-hidden="true"></i>
          </button>
          <input
            className=" col-7 form-control "
            onChange={(e) => this.setState({ notes: e.target.value })}
            type="text"
            placeholder="Notes"
            width="100%"
            value={this.state.notes}
          />
          <button 
          disabled={this.props.authorized}
          onClick={this.serverUploadFormat} className="btn btn-success">
            Save
          </button>
        </div>
        <div id="canvas">
          <div id="editorCanvas">
            <img
              alt=""
              src={`${this.props.imgPath}`}
              // style={{ zoom: this.state.zoomLevel + "%" }}
              className="editor-image extra_img"
              onClick={this.click}
              onError={(img_comp) =>
                (img_comp.target.src = require("../../assets/img/brand/default-image.png"))
              }
            />
            {dents.map((row, i) => {

              // const arr = row.split(" ");
              // const x = arr[1];
              // const y = arr[2];
              // const size = arr[3] > 20 ? 50 : 30;
              const size = row.size;
              const x = row.x;
              const y = row.y;

              return (
                <div
                  onClick={() => this.remove(i)}
                  key={i}
                  style={{
                    height: parseInt(size),
                    width: parseInt(size),
                    border: `5px solid ${colorCode[row.type]}`,
                    top: `${y}px`,
                    left: `${x}px`,
                    zoom: this.state.zoomLevel + "%",
                  }}
                  className="dent-spot"
                >
                  {/* <span className="textgd">({size})</span> */}
                  {/* <button className="deleteBtn">X</button> */}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
